<template>
    <div class="header-solutions">
        <component
            :is="isShort ? 'header-short' : 'header-main'"
            v-bind="$props"
        >
            <template #top-nav>
                <header-top-nav
                    :logo="logo"
                    :menu-links="menuLinks"
                    :buttons="menuButtons"
                    :menu-open-title="menuOpenTitle"
                    :menu-close-title="menuCloseTitle"
                />
            </template>
        </component>
        <div ref="triggerSticky" />
        <div v-if="showSticky" class="sticky">
            <header-sticky :title="stickyTitle" :cta-buttons="ctaButtons" />
        </div>
    </div>
</template>

<script>
import HeaderMain from './components/header-main.vue';
import HeaderShort from './components/header-short.vue';
import HeaderSticky from './components/header-sticky.vue';
import HeaderTopNav from './components/header-topnav.vue';

export default {
    name: 'SolutionsHeader',

    components: {
        HeaderMain,
        HeaderTopNav,
        HeaderSticky,
        HeaderShort,
    },

    props: {
        logo: {
            type: Object,
            default: () => ({}),
        },
        menuLinks: {
            type: Array,
            default: () => [],
        },
        label: {
            type: Object,
            default: null,
        },
        title: {
            type: String,
            required: true,
        },
        lead: {
            type: String,
            default: '',
        },
        bodyText: {
            type: String,
            default: '',
        },
        stickyTitle: {
            type: String,
            default: '',
        },
        menuButtons: {
            type: Array,
            default: () => [],
        },
        ctaButtons: {
            type: Array,
            default: () => [],
        },
        video: {
            type: Object,
            required: true,
        },
        menuOpenTitle: {
            type: String,
            required: true,
        },
        menuCloseTitle: {
            type: String,
            required: true,
        },
        isShort: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            showSticky: false,
            stickyObserver: undefined,
        };
    },

    mounted() {
        const options = {
            root: null,
            rootMargin: '0px',
            threshold: 1.0,
        };

        if (typeof IntersectionObserver === 'undefined') return;
        this.stickyObserver = new IntersectionObserver(this.onHeaderScrolled, options);
        this.stickyObserver.observe(this.$refs.triggerSticky);
    },

    beforeUnmount() {
        if (!this.stickyObserver) return;
        this.stickyObserver.disconnect();
    },

    methods: {
        onHeaderScrolled(res) {
            this.showSticky = !res[0].isIntersecting;
        },
    },
};
</script>
